import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FootballTeam from '../components/FootballTeam';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { connect } from 'react-redux';

@connect(
  state => {
    return {
      match: state.football.match
    };
  }
)

export default class FootballLiveMatchHomeTeam extends Component {

  static propTypes = {
    matchLabel: PropTypes.string,
    match: PropTypes.object,
    params: PropTypes.object
  }

  render() {
    const match = this.props.match[this.props.params.matchId].match;
    return (
      <div>
        <div className="awayTeam">
          <MetaDataWrapper title={`${this.props.matchLabel} - Away Team`}/>
          <FootballTeam team={match.awayTeam} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballLiveMatchAwayTeam.js